class Constants {
  static get els() {
    let constants = {
      quickShopTrigger: '[data-quickshop-view]',
      quickShopContainer: '[data-quickshop]',
      quickShopUnderlay: '[data-quickshop-underlay]',
      quickShopCloseBtn: '[data-quickshop-close]',
      quickShopAddToCartBtn: '[data-quickshop-add-to-cart]',
      quickShopProductForm: '[data-quickshop-product-form]',
      quickShopQuantityInput: '[data-quickshop-quantity]',
      quickShopQuantityIncrease: '[data-quickshop-quantity-increase]',
      quickShopQuantityDecrease: '[data-quickshop-quantity-decrease]',
      quickShopVueComponent: '#quickshop-component',
    };
    return constants;
  }
}
export { Constants };
